<template>
  <RevCheckbox
    :model-value="modelValue"
    @update:model-value="
      (value: boolean | string[]) => emit('update:modelValue', value)
    "
  >
    <template #label>
      <FormattedMessage :definition="translations.termsAndCondition">
        <template #termsOfDistanceSelling>
          <RevLink
            target="_blank"
            to="https://www.bouyguestelecom.fr/static/cms/tarifs/Conditions_Generales_De_Vente_A_Distance.pdf"
            >{{ i18n(translations.termsOfDistanceSelling) }}
          </RevLink>
        </template>
        <template #termsOfService>
          <RevLink
            target="_blank"
            to="https://www.bouyguestelecom.fr/static/cms/tarifs/conditions-generales-de-service.pdf"
            >{{ i18n(translations.termsOfService) }}
          </RevLink>
        </template>
        <template #termsOfPricing>
          <RevLink
            target="_blank"
            to="https://www.bouyguestelecom.fr/static/cms/tarifs/guide-des-tarifs-gp-octobre-2023.pdf"
            >{{ i18n(translations.termsOfPricing) }}
          </RevLink>
        </template>
        <template #contractualSummary>
          <RevLink
            v-if="mobilePlanSelected === 'BOUYGUES_150GO'"
            target="_blank"
            to="https://www.bouyguestelecom.fr/static/cms/tarifs/recapitulatif-contractuel-forfait-150go-5g-octobre-2023.pdf"
            >{{ i18n(translations.contractualSummary) }}
          </RevLink>
          <RevLink
            v-if="mobilePlanSelected !== 'BOUYGUES_150GO'"
            target="_blank"
            to="https://www.bouyguestelecom.fr/static/cms/tarifs/recapitulatif-contractuel-forfait-200go-5g-octobre-2023.pdf"
            >{{ i18n(translations.contractualSummary) }}
          </RevLink>
        </template>
        <template #privacyPolicy>
          <RevLink
            target="_blank"
            to="https://www.bouyguestelecom.fr/static/cms/tarifs/Politique_De_Confidentialite.pdf"
            >{{ i18n(translations.privacyPolicy) }}
          </RevLink>
        </template>
      </FormattedMessage>
    </template>
  </RevCheckbox>
</template>

<script setup lang="ts">
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCheckbox } from '@ds/components/Checkbox'
import { RevLink } from '@ds/components/Link'

import translations from './TermsAndConditionsCheckbox.translations'

const i18n = useI18n()

defineProps<{
  modelValue: boolean
}>()

// TODO: B2CS-121 Replace this const with the actual variable retrieve from checkout
const mobilePlanSelected = 'BOUYGUES_150GO'

const emit = defineEmits(['update:modelValue'])
</script>
